<template>
    <div class="color-picker">
        <div v-if="preview" class="color-picker__preview" :style="{ 'backgroundColor': value }"></div>
        <div id="color-picker" :value="value" @input="updateValue($event.target.value)"></div>
    </div>
</template>

<script>
    import iro from "@jaames/iro";
    import * as detector from 'detect-browser';

    export default {
        props: {
            value: String,
            preview: {
                type: Boolean,
                default: false,
            },
        },
        data () {
            return {
                colorPicker: null,
                browser: detector.detect(),
            }
        },
        methods: {
            updateValue (value) {
                this.$emit('input', value);
            },
        },
        mounted() {
            this.colorPicker = new iro.ColorPicker("#color-picker", {
                width: 180,
                height: 260,
                color: this.value,
                borderWidth: 9,
                borderColor: '#DCDCDC',
            });

            this.colorPicker.on("color:change", (color) => {
                this.updateValue(color.hexString);
            });

            // Fix color picker component
            setTimeout(() => {
                const fillCircle = document.querySelector('.iro__wheel__saturation')
                    .getAttribute('fill').match(/(#iro[A-Z]\w+)/g)[0];
                const fillRectangle = document.querySelector('.iro__slider__value')
                    .getAttribute('fill').match(/(#iro[A-Z]\w+)/g)[0];

                document.querySelector('.iro__wheel__saturation').setAttribute('fill', `url(${fillCircle})`);
                document.querySelector('.iro__slider__value').setAttribute('fill', `url(${fillRectangle})`);
            }, 100);
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/Code/properties/ColorPicker.vue